import contentTypes from "@/view/constants/contentTypes";

import type {
  Article,
  AssignmentMember,
  Bundle,
  GenerationGeniusAPIResponse,
  InteractiveVideo,
  NestedAssignmentMember,
} from "@/types/models";
import type { IRecommendedReadingLevel } from "@/types/models/ReadingLevel.interface";

export function isArticle(data: any): data is Article {
  return data && (data as Article).content_type === contentTypes.ARTICLE;
}

export function isBundle(data: any): data is Bundle {
  return data && data.content_type === contentTypes.BUNDLE;
}

export function isNestedAssignmentMember(
  data: AssignmentMember | NestedAssignmentMember | undefined | null,
): data is NestedAssignmentMember {
  return Boolean(data && (data as NestedAssignmentMember).content);
}

export function isRecommendedReadingLevel(
  data: any,
): data is IRecommendedReadingLevel {
  return (
    data &&
    (data as IRecommendedReadingLevel).recommended_article_level_content_id
  );
}

type Video = InteractiveVideo | GenerationGeniusAPIResponse;

export function isInteractiveVideo(data: any): data is InteractiveVideo {
  return data && data.content_type === contentTypes.INTERACTIVE_VIDEO;
}

export function isGenerationGeniusVideo(
  data: any,
): data is GenerationGeniusAPIResponse {
  return data && data.content_type === contentTypes.GENERATION_GENIUS_VIDEO;
}

export function isVideo(data: any): data is Video {
  return isInteractiveVideo(data) || isGenerationGeniusVideo(data);
}
